export const BODY = 'body';
export const FIELD = 'field';
export const FORMGROUP = 'formgroup';
export const PAGE_TITLE = 'pageTitle';
export const TITLE = 'title';
export const POINTS = 'points';
export const BODY_PROF = 'bodyProf';
